import styled, { css } from 'styled-components';
import { mediaMixin, Text, token } from '@zillow/constellation';

export const ClaimListingCardContainer = styled.div`
    border-top: 1px solid ${token('colors.gray300')};
    border-bottom: 1px solid ${token('colors.gray300')};
    max-height: 940px;
    overflow-y: auto;
`;

export const StyledDesktopText = styled(Text)`
    display: none;

    ${mediaMixin(
        'md',
        css`
            display: initial;
        `
    )}
`;

export const StyledMobileText = styled(Text)`
    display: none;

    ${mediaMixin(
        'sm_lte',
        css`
            display: initial;
        `
    )}
`;

export const StyledContactMethodText = styled(Text)`
    && {
        font-weight: 700;
        display: inline-block;
    }
`;
